export const HEADER_SUCCESS = 'Success!'
export const BODY_TYPE_PREFIX_CLASS = 'class'
export const BODY_TEXT_CREATE = `You've created your`
export const BODY_TEXT_EDIT = `You've updated your`
export const BUTTON_SUBMIT = 'Go to class'
export const MAX_CLASSES_REACHED =
  'You’ve now reached the maximum number&nbsp;of classes.'
